const faqSearch = (() =>{
    const initBlock = el => {
        
        const input = el.querySelector('input');
        const dropdown = el.querySelector('[data-dropdown]')
        const dropdownWrapper = el.querySelector('[data-results]');
        
        input.addEventListener('focusin', () => {
            dropdown.classList.add('form-group__dropdown--open');
        });
        
        input.addEventListener('focusout', () => {
            setTimeout(() => {
                dropdown.classList.remove('form-group__dropdown--open');
            }, 200);
        });
        
        input.addEventListener('input', (e) => {
            dropdownWrapper.querySelectorAll('a').forEach(result => {
                if (result.innerHTML.toLowerCase().includes(input.value.toLowerCase())) {
                    result.classList.remove('hidden');
                }else{
                    result.classList.add('hidden');
                }
            });
        })
        
    }
    return {initBlock};
})();
ControlBinders.register(`[data-faq-search]`, el => faqSearch.initBlock(el));